<template>
  <div>
    <div v-if="showtoolbar" class="px-0">
      <b-row class="px-0 mt-0">
        <b-col cols="auto">
          <b-button-group class="z-0">
            <b-row align-h="start" no-gutters>
              <b-col class="gridtoolbar" cols="auto" v-for="(tool, index) in toolbar.filter((o) =>
                o.position.includes('toolbar')
              )" :key="index">
                <b-button v-if="tool.type == 'button' && tool.visible" :id="'toolClick' + tool.action" :size="tool.size"
                  :variant="tool.variant" :title="tool.title ? tool.title : toolLabel(tool)"
                  :squared="tool.squared ? 'squared' : null" :disabled="tool.disabled"
                  @click="toolClick($event, tool.action, checked_items)">
                  <!-- :disabled="
                      tool.action == 'paste'
                        ? $store.state.clipboard
                          ? false
                          : true
                        : tool.disabled
                    " -->
                  <i v-if="toolIcon(tool)" :class="toolIcon(tool)"></i>
                  <span v-if="toolLabel(tool)" v-html="toolLabel(tool)"> </span>
                  <i v-if="tool.icon2" :class="tool.icon2"></i>
                </b-button>
              </b-col>
            </b-row>
          </b-button-group>
        </b-col>
      </b-row>

      <div v-if="showfab" :class="fab_bar ? 'btn-group-fab active' : 'btn-group-fab'" role="group" aria-label="FAB Menu"
        @click="fab_bar = !fab_bar">
        <div>
          <button id="menu" type="button" class="btn btn-main btn-primary has-tooltip" data-placement="left">
            <!-- title="Menu" -->
            <i :class="fab_bar ? 'fa fa-times' : 'fa fa-bars'"></i>
          </button>
          <b-tooltip target="menu" placement="right">Click for actions</b-tooltip>
          <div v-for="(tool, index) in toolbar.filter((o) =>
            o.position.includes('toolbar')
          )" :key="index">
            <b-button :id="'fab_' + tool.action" type="button" class="btn btn-sub btn-outline-primary has-tooltip"
              data-placement="left" :style="'bottom: ' + bottom(index) + 'px'"
              @click="toolClick($event, tool.action, checked_items)">
              <i v-if="toolIcon(tool)" :class="toolIcon(tool)"></i>
              <!-- :title="tool.tooltip ? tool.tooltip : toolLabel(tool)" -->
            </b-button>
            <b-tooltip :target="'fab_' + tool.action" placement="right">{{
              tool.tooltip ? tool.tooltip : toolLabel(tool)
            }}</b-tooltip>
          </div>
        </div>
      </div>
    </div>
    <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
      <b-overlay :show="dirty" opacity=".5" spinner-type="none">
        <div v-if="items.length == 0" class="emptyreport z-0">
          <div class="b-table-sticky-header" style="margin-bottom: 0">
            <table class="reporttable table b-table table-striped table-sm">
              <thead>
                <tr>
                  <!-- <i class="fa fa-caret-down" aria-hidden="true"></i> -->
                  <th class="text-center"><i class="fa fa-caret-down" aria-hidden="true"></i></th>
                  <th v-for="index in 12" :key="index" class="text-center w-8pct">
                    {{ String.fromCharCode(64 + index) }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="index in 6" :key="index">
                  <td>&nbsp;</td>
                  <td v-for="index in 12" :key="index">&nbsp;</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-if="items.length > 0" class="b-table-sticky-header z-0"
          :style="'margin-bottom: 0;max-height: 1200px !important'">
          <table :class="textsize + ' reporttable table b-table table-striped table-sm'
            ">
            <thead>
              <tr>
                <!-- <i class="fa fa-caret-square-o-down" aria-hidden="true"></i> -->
                <th class="text-center"> <i class="fa fa-caret-down" aria-hidden="true"></i></th>
                <th v-for="(head, hindex) in fields" :key="'h_' + hindex" :class="head.class ? head.class : null">
                  {{ head.label }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, rindex) in items" :key="'r_' + rindex" :class="rowclass(row)">
                <!-- {{Object.values(row).includes('Report Totals')}} -->
                <td class="background-primary-dark text-white text-right"><span class="small ml-1 mr-1">{{ rindex + 1
                    }}</span></td>
                <td v-for="(cell, cindex) in fields" :key="'c_' + cindex" :class="cell.class ? cell.class : null">
                  {{ row[cell.key] }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-overlay>
    </b-overlay>

    <b-row v-if="showsheets" class="excelsheetbuttons mt-0">
      <b-col>
        <b-button-group>
          <b-button v-for="(tool, index) in



            toolbar.filter((t) =>
              t.action.includes('sheet_')
            )



" :key="index" :size="tool.size" :variant="tool.variant" :title="tool.tooltip ? tool.tooltip : toolLabel(tool)"
            :id="'sheet_' + tool.action" :pressed="table_tab == index" :disabled="tool.disabled" type="button"
            class="status" @click="table_tab = index;
            toolClick(null, tool.action);
            ">
            <i v-if="toolIcon(tool)" :class="toolIcon(tool)"></i>
            {{ tool.label }}
          </b-button>
        </b-button-group>
      </b-col>
    </b-row>

    <!-- </b-overlay>  -->
    <b-row v-if="!component" class="excelsheetbuttons mt-3">
      <b-col class="text-left">
        <span v-if="!busy && showrowcount" class="small text-primary">Found {{ table_size }} rows
        </span>
      </b-col>
      <b-col v-if="showpages" class="text-right">
        <b-pagination hide-ellipsis v-if="table_size > 0" v-model="table_page" :total-rows="table_size"
          :per-page="table_limit" align="right" size="sm"></b-pagination>
      </b-col>
      <b-col v-if="showpages" class="ml-2" cols="auto">
        <div class="pagelimit">
          <treeselect v-model="table_limit" :clearable="false" :options="options_pagesizes" size="sm" inline>
          </treeselect>
        </div>
      </b-col>
    </b-row>

    <b-modal id="download-file" v-model="download_show" centered title="Download" @close="handleCancel()"
      :modal-class="{ 'c-dark-theme': $store.state.darkMode }">

      <template #default="{ hide }">

        <form ref="form" @submit.stop.prevent="handleSubmit">
          <b-col cols="12" sm="12" md="12" xl="12">
            <b-form-group label="Download selection" label-for="type" label-cols="12">
              <treeselect instanceId="download_type" type="number" v-model="download" :clearable="false"
                :options="options_download" @input="download_change"></treeselect>
            </b-form-group>
          </b-col>

          <b-col cols="12" sm="12" md="12" xl="12">
            <b-form-group label="File format" label-for="type" label-cols="12">
              <treeselect instanceId="download_format" type="number" v-model="download_file" :clearable="false"
                :options="options_download_file"></treeselect>
            </b-form-group>
          </b-col>
          <b-col class="mt-2" cols="12" sm="12" md="12" xl="12" v-if="downloaded.length == 0">
            <i class="fa fa-cog fa-spin text-primary" style="font-size:24px"></i><span class="ml-2">One moment we are
              fetching that data for you...</span>
          </b-col>
        </form>
      </template>

      <template #modal-footer="{ ok, cancel, hide }">
        <span v-if="downloaded.length > 0" class="mr=4">Ready to export {{ downloaded.length }} row(s)</span>

        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" variant="outline-primary" @click="handleSubmit()" :disabled="downloaded.length == 0">
          <i :class="downloading ? 'fa fa-refresh fa-spin text-info mr-1' : 'fa fa-download text-info mr-1'"></i>
          <span v-text="downloading ? 'Downloading' : 'Download It'"></span>
        </b-button>
        <b-button size="sm" variant="secondary" @click="handleCancel()">
          <i class="fa fa-chevron-left pr-1"></i>Back
        </b-button>
        <!-- Button with custom close trigger value -->
        <!-- <b-button size="sm" variant="outline-secondary" @click="hide('forget')">
          Forget it
        </b-button> -->
      </template>
    </b-modal>

  </div>
</template>

<script>
import * as toolsetup from "./toolsetup";
import * as fs from "file-saver";

const notInArr = function notInArr(item) {
  return this.indexOf(item) === -1;
};

function addCheckedSubset(current, add) {
  if (!current.length) return add;

  // Add only messages which are not already checked
  return current.concat(add.filter(notInArr, current));
}

function removeCheckedSubset(current, remove) {
  // Return only messages which are not in subset
  return current.filter(notInArr, remove);
}

export default {
  name: "r_table",
  props: {
    classdivtable: {
      type: String,
      default:
        "table b-table table-sm table-striped datatable flightstable multiuser",
    },
    title: { type: String, default: "" },
    refid: { type: String, default: "r-table" },
    busy: { type: Boolean, default: false },
    dirty: { type: Boolean, default: false },
    icon: { type: String, default: "fa fa-power-off text-primary" },
    pagesize: { type: Number, default: 15 },
    tools: { type: String, default: "" },
    toolbar: {
      type: Array,
      default() {
        return [];
      },
    },
    toolbarlibrary: {
      type: Array,
      default() {
        return [];
      },
    },
    fields: {
      type: Array,
      default() {
        return [];
      },
    },
    badges: {
      type: Array,
      default() {
        return [];
      },
    },
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    downloaded: {
      type: Array,
      default() {
        return [];
      },
    },
    selectall: { type: Boolean, default: false },
    debounce: { type: Number, default: 500 },
    showtoolbar: { type: Boolean, default: true },
    showfab: { type: Boolean, default: true },
    showsheets: { type: Boolean, default: false },
    showpages: { type: Boolean, default: true },
    showrowcount: { type: Boolean, default: true },
    showautoadd: { type: Boolean, default: false },
    page: { type: Number, default: 1 },
    limit: { type: Number, default: 15 },
    offset: { type: Number, default: 0 },
  },
  data() {
    return {
      table_tab: 0,
      table_page: 1,
      table_size: 0,
      table_limit: 15,
      table_offset: 0,
      height: 600,
      rows: [],
      checked_items: [],
      // tlist: toolsetup.default.library,
      toolbarlibrary_: toolsetup.default.library,
      overlay_show: false,
      overlay: {},
      rows_checked: false,
      fab_bar: false,
      textsize: "",
      options_pagesizes: [
        { id: 10, label: "10" },
        { id: 15, label: "15" },
        { id: 25, label: "25" },
        { id: 50, label: "50" },
        { id: 5000, label: "All" },
      ],
      download_show: false,
      download: "download_view",
      options_download: [
        { id: "download_view", label: "Current page" },
        // { id: "download_all", label: "All pages" },
      ],
      download_file: "download_xlsx",
      options_download_file: [
        { id: "download_xlsx", label: "Excel Workbook (*.xlsx)" },
        { id: "download_txt", label: "Text (Tab delimited) (*.txt)" },
        { id: "download_csv", label: "CSV (Comma delimited) (*.csv)" },
      ],
      downloading: false,
    };
  },
  mounted() {
    document.addEventListener("keyup", this.keyupHandler);
  },
  destroyed() {
    document.removeEventListener("keyup", this.keyupHandler);
  },
  watch: {
    items: {
      immediate: true,
      async handler(newVal, oldVal) {
        console.log("in r-table items", newVal.length);
        if (newVal) {
          this.table_size = newVal.length;

          if (newVal.length == 0) {
            for (var i = 0; i < 9; i++) {
              let find = this.toolbar.find(o => o.action == 'sheet_' + i)
              if (find) {
                let reset = this.toolbarlibrary_.find(o => o.action == 'sheet_' + i);
                find.label = reset.label
              }
            }
          }
        }
      },
    },
    toolbarlibrary: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (newVal) {
          // ADD NEW TOOLS TO THE INNER toolbar_library
          for (var i = 0; i < newVal.length; i++) {
            let tool = newVal[i];
            if (tool.action) {
              let found = this.toolbarlibrary_.find(
                (o) => o.action == tool.action
              );
              if (!found) {
                if (!tool.disabled) {
                  tool.disabled = true;
                }
                this.toolbarlibrary_.push(tool);
              }
            }
          }
        }
      },
    },
    tools: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (newVal) {
          newVal = newVal
            .split("default")
            .join("back,save,filter,go,export,add,edit,deleteconfirm");
          let list = newVal.split(",");

          for (var i = 0; i < list.length; i++) {
            let found = this.toolbar.find((o) => o.action == list[i]);
            if (!found) {
              let tool = this.toolbarlibrary_.find((o) => o.action == list[i]);
              if (tool) {
                tool.disabled = true;
                tool.visible = true;
                this.toolbar.push({ ...tool });
              }
            }
          }
          this.$emit("select", [], this.toolbar);
        }
      },
    },
    showpages: {
      immediate: true,
      async handler(newVal, oldVal) {
        if (newVal) {
          this.height = 350;
        } else {
          this.height = 1000;
        }
      },
    },
    showautoadd: {
      immediate: true,
      async handler(newVal, oldVal) {
        this.items = this.items.filter((i) => i.id);
      },
    },
    limit: {
      immediate: true,
      async handler(newVal, oldVal) {
        this.setLimit(newVal);
      },
    },
    page: {
      immediate: true,
      async handler(newVal, oldVal) {
        this.setPage(newVal);
      },
    },
    table_limit: {
      immediate: true,
      async handler(newVal, oldVal) {
        this.setLimit(newVal);
      },
    },
    table_page: {
      immediate: true,
      async handler(newVal, oldVal) {
        console.log("page changed to", newVal);
        this.setPage(newVal);
      },
    },
  },
  computed: {
    allAreChecked() {
      const checked = this.checked_items.length;
      return checked === this.rows.length;
    },
    actionsfab() {
      let tools = this.toolbar.filter((o) => o.position.includes("toolbar"));

      let fabs = [];
      for (var i = 0; i < tools.length; i++) {
        let tool = tools[i];
        fabs.push({
          name: "tool('" + tool.action + "')",
          // icon: tool.icon_material ? tool.icon_material : "not_listed_location",
          // color: tool.icon_color ? tool.icon_color : null,
          tooltip: tool.label ? tool.label : null,
        });
      }
      return fabs;
    },
  },
  methods: {
    cleanit(dirty) {
      let cleaned = [];
      for (var j = 0; j < dirty.length; j++) {
        let item = JSON.parse(JSON.stringify(dirty[j]));
        delete item.index;

        let empty = true;
        for (var i = 0; i < this.fields.length; ++i) {
          let field = this.fields[i];

          // DONT REMOVE THE KEY/VALUE ON CLEARABLE
          if (field.type == "treeselect") {
            if (!item[field.key]) {
              console.log(field.key, "is missing");
              item[field.key] = "";
            }
          }

          if (field.type == "daterangepicker") {
            if (item[field.key]) {
              let value = [];
              if (item[field.key].startDate) {
                value.push(
                  this.$moment(item[field.key].startDate).format("YYYY-MM-DD")
                );
                empty = false;
              } else {
                value = "";
              }
              if (item[field.key].endDate) {
                value.push(
                  this.$moment(item[field.key].endDate).format("YYYY-MM-DD")
                );
                empty = false;
              }
              item[field.key] = value;
            }
          } else {
            if (item[field.key]) {
              empty = false;
            }
          }
        }
        if (!empty) {
          cleaned.push(item);
        }
      }
      return cleaned;
    },
    toggleAll(evt) {
      console.log("toggle all", this.allAreChecked);
      const list = this.allAreChecked
        ? []
        : this.rows.slice(0, this.rows.length);
      this.checked_items = list;
    },
    toggleRow(evt, index) {
      console.log("toggle row", evt, index);

      const savedIndex = this.savedIndex;
      this.savedIndex = index;

      // If this is the first pass or no shift key was
      // pressed, just bail.
      if (savedIndex === null || !evt.shiftKey) return;

      // Shift-clicked the same message :-/
      if (index === savedIndex) return;

      // Get the subset of the message list between the
      // two indicies.
      // console.time("toggle range");
      const subset = this.items.slice(
        Math.min(index, savedIndex),
        Math.max(index, savedIndex) + 1
      );
      // Determine the operation based on the checked state
      // of the clicked checkbox.
      const toggleFn = evt.currentTarget.checked
        ? addCheckedSubset
        : removeCheckedSubset;

      this.checked_items = toggleFn(this.checked_items, subset);
      console.log("these are checked", this.checked_items);
      // console.timeEnd("toggle range");
    },
    actionsvalid(item) {
      var valid = [];

      let actions = this.toolbar.filter((o) => o.position.includes("actions"));

      for (var i = 0; i < actions.length; i++) {
        let action = actions[i];
        if (action.visible) {
          if (action.rule) {
            var rule = action.rule;
            var op = rule.toString().substring(0, 1);
            var equalTo = true;
            if (op == "!") {
              equalTo = false;
              rule = rule.substring(1);
            }
            if (item.hasOwnProperty(rule)) {
              var state = item[rule];
              if (
                (state == true && equalTo == true) ||
                (state == false && equalTo == false)
              ) {
                valid.push(action);
              }
            } else {
              valid.push(action);
            }
          } else {
            valid.push(action);
          }
        }
      }
      return valid;
    },
    badgecolor(k, v) {
      let r = "white";
      let find = this.badges.find((o) => o.key == k);
      if (find) {
        if (find[v]) {
          r = find[v];
        } else {
          r = "danger";
        }
      }
      return r;
    }, // TOOLBAR HELPERS
    toolLabel(a) {
      switch (a.action) {
        case "filter":
          return this.showfilter ? "Filter On" : "Filter Off";
        case "autoquery":
          return this.autoquery ? "Auto On" : "Auto Off";
        default:
          return a.label;
      }
    },
    download_change() {
      this.$emit("click", this.download);
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.nameState = valid
      return valid
    },
    resetModal() {
      this.name = ''
      this.nameState = null
    },
    handleOk(bvModalEvent) {
      // Prevent modal from closing
      bvModalEvent.preventDefault()
      // Trigger submit handler
      this.handleSubmit()
    },
    handleCancel() {
      console.log('you cancelled')
      //Hide the modal manually
      this.$nextTick(() => {
        this.$bvModal.hide('download-file')
      })
      this.$emit("load", 0, 15, 1);
    },
    async handleSubmit() {

      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }

      this.downloading = true

      let file = null
      let buffer = null
      let filename = 'export' + this.$moment().format("_YYYYDDMMHHMMSS")
      switch (this.download_file) {
        case "download_xlsx":
          await this.excel_sheet({ items: this.downloaded, fields: this.fields, });
          break;

        case "download_txt":
          file = await this.outputTXT("\t", this.downloaded);
          buffer = Buffer.from(file, "utf8");
          fs.saveAs(new Blob([buffer], { type: "text/csv;charset=utf-8" }), filename + ".txt");
          break;

        case "download_csv":
          file = await this.outputTXT(",", this.downloaded);
          buffer = Buffer.from(file, "utf8");
          fs.saveAs(new Blob([buffer], { type: "text/csv;charset=utf-8" }), filename + ".csv");
          break;
      }

      this.downloading = false
    },

    async outputTXT(delim, downloaded) {

      if (!delim) {
        delim = "\t"
      }
      let result = "";

      let fields = this.fields
      let items = this.items
      if (downloaded) { items = downloaded }

      for (let j = 0; j < items.length; j++) {
        let line = "";

        // HEADER
        if (j == 0) {
          for (let k = 0; k < fields.length; k++) {
            if (fields[k].key == "selected" || fields[k].key == "icon" || fields[k].key == "actions") {
            } else {
              line += fields[k].label + delim;
            }
          }
          if (line.length > 0) {
            line = line.slice(0, -1);
          }
          result += line + "\n";
          line = "";
        }

        let obj = items[j];

        // USE FIELDS IN CASE AN OBJECT IS NOT COMPLETE
        for (let k = 0; k < fields.length; k++) {
          let value = "";
          let prop = ""
          if (fields[k].key == "selected" || fields[k].key == "icon" || fields[k].key == "actions") {
          } else {
            value = obj[fields[k].key] ? obj[fields[k].key] : ""
            if (
              (this.fields[k].key.toLowerCase().includes('date') ||
                this.fields[k].key.toLowerCase().includes('modified') ||
                this.fields[k].key.toLowerCase().includes('issued') ||
                this.fields[k].key.toLowerCase().includes('invoice_at') ||
                this.fields[k].key.toLowerCase().includes('travel_at') ||
                this.fields[k].key.toLowerCase().includes('start_at')
              ) && !this.fields[k].key.toLowerCase().includes('updated') && !this.fields[k].key.toLowerCase().includes('dateissued') && !this.fields[k].key.toLowerCase().includes('datetravel')) {

              if (value) {
                if (!this.$moment(value).isValid()) {
                  value = this.$moment.unix(parseFloat(value) / 1000).utc(false).format("DD/MM/YY")
                }
              }
            }
            if (value) {
              value = value
                .toString()
                .replace(/(\r\n|\n|\r)/gm, "")
                .replace(/""/g, '"');
            }

            prop = fields[k].key.toLowerCase()
            line += value + delim;
          }

        }
        if (line.length > 0) {
          line = line.slice(0, -1);
        }

        result += line + "\n";
      }

      return result;
    },

    async toolClick($event, a, s) {

      this.overlay_show = false;
      let tool = this.toolbar.find((o) => o.action == a);
      if (tool.disabled) {
        return;
      }

      switch (a) {
        case "sheet_0":
        case "sheet_1":
        case "sheet_2":
        case "sheet_3":
        case "sheet_4":
        case "sheet_5":
        case "sheet_6":
        case "sheet_7":
        case "sheet_8":
        case "sheet_9":
          break;

        case "filter":
          this.showfilter = !this.showfilter;
          break;

        case "download":
          if (this.items.length > 0) {
            if (!this.download_show) {
              this.download = "download_view"
              this.download_file = "download_xlsx"
              this.downloaded = this.items
            }
            this.download_show = !this.download_show;
          }
          break;

        case "autoquery":
          this.autoquery = !this.autoquery;
          break;

        case "cut":

        case "copy":
          await navigator.clipboard.writeText(await this.outputTSV());
          break;

        // case "pastespecial":
        //   this.$bvModal.show("Pastespecial");
        //   break;

        case "notes":
          this.$bvModal.show("NotesEdit");
          break;

        case "insert":
          this.items.push({ ...this.items[this.items.length - 1] });
          this.items[this.items.length - 1].id = "";
          this.items[this.items.length - 1].line = this.items.length.toString();
          break;

        case "textsize":
          this.changeTextSize();
          break;

        case "export":
          await this.excel_sheet({
            items:
              this.checked_items.length > 0
                ? this.cleanit(this.checked_items)
                : this.cleanit(this.items),
            fields: this.fields,
          });
          break;

        default:
          // LAST SELECTED ITEM IS THE ACTIVE ONE
          this.checked_items = s;
          let item = null;
          if (s) {
            item = s[0];
          }
          // MIXIN COMPAITBILITY
          this.selection = s;

          let toolactive = this.toolbar.find((o) => o.action == a);
          // CLEAR THE SELECTION IF ADDING!
          if (a == "add") {
            this.selection = [];
          } else {
          }

          if (toolactive) {
            if (toolactive.hasOwnProperty("overlay")) {
              if (toolactive.overlay.message) {
                let message = toolactive.overlay.message;
                for (var prop in item) {
                  if (Object.prototype.hasOwnProperty.call(item, prop)) {
                    message = message.split("%" + prop + "%").join(item[prop]);
                  }
                }
                // IF WE DID NOT ALREADY HAVE IT IN DATA MAKE THE INDEX FROM THE LIST
                // message = message.split("%index%").join(index);
                this.overlay.message = message;
              }
              if (toolactive.overlay.buttons) {
                this.overlay.buttons = toolactive.overlay.buttons;
              }
              this.overlay_show = !this.overlay_show;
              return;
            }
          }
          break;
      }
      try {
        this.$emit("click", a, s ? this.cleanit(s) : []);
      } catch (error) { }
    },
    bottom(index) {
      let result = 0;
      if (this.fab_bar) {
        if (index == 0) {
          result = 60;
        } else {
          result = 60 + index * 50;
        }
      }
      return result;
    },
    rowIcon(r) {
      let result = this.icon;
      if (!r.id) {
        result = "fa fa-plus text-primary";
      }
      if (r.running == 1 || r.runnow == 1) {
        result += " text-warning";
      } else {
        // result += " text-primary";
      }
      return result;
    },
    async outputTSV() {
      let result = "";
      for (var j = 0; j < this.items.length; j++) {
        let line = "";

        // HEADER
        if (j == 0) {
          for (var k = 0; k < this.fields.length; k++) {
            line += this.fields[k].label + "\t";
          }
          if (line.length > 0) {
            line = line.slice(0, -1);
          }
          result += line + "\n";
          line = "";
        }

        let obj = this.items[j];

        // USE FIELDS IN CASE AN OBJECT IS NOT COMPLETE
        for (var k = 0; k < this.fields.length; k++) {
          let value = "";
          if (obj[this.fields[k].label] || obj[this.fields[k].label] === 0) {
            value = obj[this.fields[k].label]
              .toString()
              .replace(/(\r\n|\n|\r)/gm, "")
              .replace(/""/g, '"');
          }
          line += value + "\t";
        }

        // for (var prop in obj) {
        //   let value = " ";
        //   if (obj[prop] || obj[prop] === 0) {
        //     value = obj[prop]
        //       .toString()
        //       .replace(/(\r\n|\n|\r)/gm, "")
        //       .replace(/""/g, '"');
        //   } else {
        //   }

        // }
        if (line.length > 0) {
          line = line.slice(0, -1);
        }
        result += line + "\n";
      }
      return result;
    },
    async keyupHandler(event) {
      if (event.ctrlKey && event.key === "v") {
        let text = "";
        if (navigator.clipboard) {
          text = await navigator.clipboard.readText();
        }
        console.log(text);
      }
    },

    // copy text TO the clipboard
    // await navigator.clipboard.writeText('This text is now in the clipboard');

    // get text FROM the clipboard
    // let text = await navigator.clipboard.readText();

    pasteHandler(event) {
      var pastedText =
        event.clipboardData.getData("Text") ||
        event.clipboardData.getData("text/plain");

      if (!pastedText && pastedText.length) {
        return;
      }

      // Parse the pasted text from Excel into rows.
      // Pasted text is usually separated by a new line for each row,
      // but a single cell can contain multiple lines, which is what
      // we pars out in the first `replace`.
      //
      // We find all text within double-quotes ('"') which has new
      // lines, and put the text within the quotes into capture
      // groups. For each match, we replace its contents again, by
      // removing the new lines with spaces.
      //
      // Then lastly, once we've joined all the multi line cells, we
      // split the entire pasted content on new lines, which gives
      // us an array of each row.
      //
      // Since Windows usually uses weird line-endings, we need to
      // ensure we check for each of the different possible
      // line-endings in every regexp.
      //
      // It also handles cells which contains quotes. There appears
      // to be two ways this is handled. In Google Docs, quotes within
      // cells are always doubled up when pasting, so " becomes "".
      // In Libre Office, the quotes are not normal quotes, some
      // other character is used, so we don't need to handle it any
      // differently.
      var rows = pastedText
        .replace(
          /"((?:[^"]*(?:\r\n|\n\r|\n|\r))+[^"]+)"/gm,
          function (match, p1) {
            // This function runs for each cell with multi lined text.
            return (
              p1
                // Replace any double double-quotes with a single
                // double-quote
                .replace(/""/g, '"')
                // Replace all new lines with spaces.
                .replace(/\r\n|\n\r|\n|\r/g, " ")
            );
          }
        )
        // Split each line into rows
        .split(/\r\n|\n\r|\n|\r/g);
      console.log(rows);
    },
    async setLimit(v) {
      if (this.showpages) {
        if (v == 10) {
          this.height = 350;
        }
        if (v == 15) {
          this.height = 600;
        }
        if (v == 25) {
          this.height = 800;
        }
        if (v == 50) {
          this.height = 1600;
        }
        if (v > 50) {
          this.height = 3600;
        }
      } else {
        this.height = 1000;
      }
      await this.$emit("load", this.table_offset, this.table_limit);
    },
    async setPage(p) {
      this.table_offset = (p - 1) * this.table_limit;
      await this.$emit("load", this.table_offset, this.table_limit);
      this.table_page = p;
    },
    rowclass(row) {
      let result = null;
      if (row) {
        if (Object.values(row).includes("Report Totals")) {
          result = "row-total";
        } else if (parseInt(row.Qty) < 0 || parseInt(row.qty) < 0) {
          result = "row-debit";
        } else if (row.Total < 0 || row.total < 0) {
          result = "row-debit";
        } else if (row.Cost < 0 || row.cost < 0) {
          result = "row-debit";
        } else if (row.Amount < 0 || row.Amount < 0) {
          result = "row-debit";
        } else if (row["SL Amount"] < 0 || row["BL Amount"] < 0) {
          result = "row-debit";
        } else if (row.Miles <= 0 || row.miles <= 0) {
          result = "row-debit";
        } else if (this.fields.find(f => f.label == "Cost to be Invoiced")) {
          if (!row["Cost to be Invoiced"]) {
            result = "row-debit";
          }
        }
      }
      return result;
    },
    changeTextSize() {
      if (this.textsize == "") {
        this.textsize = "bigger";
      } else if (this.textsize == "bigger") {
        this.textsize = "biggest";
      } else if (this.textsize == "biggest") {
        this.textsize = "biggest2";
      } else if (this.textsize == "biggest2") {
        this.textsize = "";
      }
    },
  },
};
</script>

<style></style>